var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-learn-title"},[_c('div',{staticClass:"l-learn-title-header"},[_vm._v(_vm._s(_vm.element ? _vm.element.name : ''))]),_c('span',{staticClass:"l-back",attrs:{"oncontextmenu":"return false;","draggable":"false"},on:{"click":_vm.onBack}})])
}
var staticRenderFns = []

export { render, staticRenderFns }